module.exports = __webpack_public_path__ + "static/media/Online Store 2.c52b36c4.png";